import { Options, Vue } from 'vue-class-component';
import SideMenu from '@/shared/components/side-menu/index.vue';
import { MenuItem } from '@/shared/components/side-menu/side-menu';
import { RouteN } from '@/trust-admin-app/constants/router-name';
import { accessPermitted } from '@/shared/components/helpers';
import { AuthorizedUser } from '@/trust-admin-app/models/authorized-user';
import store from '@/trust-admin-app/store';
import { Watch } from 'vue-property-decorator';

@Options({
  components: {
    SideMenu,
  }
})
export default class TrustDataMain extends Vue {

  private menuWidth = 230;

  private menuItems: MenuItem[] = [
    {
      idx: 0,
      name: 'Practices',
      path: RouteN.TA.TrustDataPractices.p,
      show: true
    },
    {
      idx: 1,
      name: 'Trust team',
      path: RouteN.TA.TrustDataTrustTeam.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataTrustTeam.r)
    },
    {
      idx: 2,
      name: 'Investigation types',
      path: RouteN.TA.TrustDataInvestigationType.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataInvestigationType.r)
    },
    {
      idx: 3,
      name: 'Banks',
      path: RouteN.TA.TrustDataBanks.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataBanks.r)
    },
    {
      idx: 4,
      name: 'Accounting software',
      path: RouteN.TA.TrustDataAccountingSoftware.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataAccountingSoftware.r)
    },
    {
      idx: 5,
      name: 'External Examiner',
      path: RouteN.TA.TrustDataExternalExaminer.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataExternalExaminer.r)
    },
    {
      idx: 6,
      name: 'External Examiner Approval',
      path: RouteN.TA.TrustDataExternalExaminerApproval.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataExternalExaminerApproval.r)
    },
    {
      idx: 7,
      name: 'External Examiner Sign-up approval',
      path: RouteN.TA.TrustDataExternalExaminerSignUpApproval.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataExternalExaminerSignUpApproval.r)
    },{
      idx: 8,
      name: 'ATCS Help and Info',
      path: RouteN.TA.TrustDataPageSettings.p,
      show: accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustDataPageSettings.r)
    },
  ];

  private menuAction(idx: number): void {
    this.$router.push({ path: this.menuItems[idx].path });
  }

  private menuClosed(num: number) {
    this.menuWidth = num;
  }

  @Watch('$route')
  public onRouteChanged(): void {
    this.setCurrentMenuItem();
  }

  created(): void {
    this.menuWidth = 230;
  }

  mounted(): void {
    this.menuItems.forEach(m => {
      m.current = false;
      if (m.path === this.$route.path) {
        m.current = true;
      }
    });
  }

  private setCurrentMenuItem() {
    this.menuItems.forEach(m => m.current = false);
    const _currentItem = this.menuItems.filter(m => {
      return m.path == this.$route.path;
    });
    if (_currentItem.length > 0) {
      this.menuItems[_currentItem[0].idx].current = true;
    }
  }

  get usrAcct(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

}

